import { useState } from "react";
import { STEP_MAP, getMin } from "./workPerformanceApi";
import styles from "./WorkPerformancePage.module.css";

const NOTE_LABEL = { target: "대상자", content: "내용", note: "비고" };

function renderNote(raw) {
  if (!raw) return null;
  let obj;
  try { obj = JSON.parse(raw); } catch { return raw; }
  if (typeof obj !== "object" || obj === null) return raw;
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {Object.entries(obj).map(([k, v]) => (
        <div key={k} style={{ fontSize: 12, color: "#475569" }}>
          <span style={{ color: "#94a3b8", marginRight: 6 }}>{NOTE_LABEL[k] || k}</span>{v}
        </div>
      ))}
    </div>
  );
}
export default function WorkPerformanceDetail({ item, onClose, onToggleStep, onEdit, onDelete }) {
  const [confirmDelete, setConfirmDelete] = useState(false);

  const totalMin = item.steps.reduce((acc, s) => acc + getMin(s), 0);
  const doneMin  = item.steps.filter(s => s.is_done).reduce((acc, s) => acc + getMin(s), 0);
  const progress = totalMin ? Math.round((doneMin / totalMin) * 100) : 0;
  const allDone  = item.steps.every(s => s.is_done);

  // ── 공통 컴팩트 버튼 스타일 ──────────────────────────
  const btnCompact = {
    padding: "3px 10px", borderRadius: 6, fontSize: 11,
    cursor: "pointer", whiteSpace: "nowrap",
    flexShrink: 0, flexGrow: 0, width: "fit-content",
    lineHeight: "normal", display: "inline-block",
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalBox} style={{ width: "auto", minWidth: 560, maxWidth: "95vw" }}>

        {/* ── 헤더 한 줄 ─────────────────────────────────── */}
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10, flexWrap: "nowrap", whiteSpace: "nowrap" }}>
          <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: "#0f172a", whiteSpace: "nowrap", flexShrink: 0 }}>
            {item.title}
          </h3>
          {allDone
            ? <span className={styles.badgeDone} style={{ whiteSpace: "nowrap", flexShrink: 0 }}>처리완료</span>
            : <span className={styles.badgeProgress} style={{ whiteSpace: "nowrap", flexShrink: 0 }}>진행중</span>
          }
          <span style={{ fontSize: 12, color: "#94a3b8", whiteSpace: "nowrap", flexShrink: 0 }}>
            📅 {item.work_date}
          </span>
          <span style={{ fontSize: 12, color: "#94a3b8", whiteSpace: "nowrap", flexShrink: 0 }}>
            👤 {item.employee_name}
          </span>
          <span style={{ fontSize: 12, fontWeight: 700, color: "#374151", whiteSpace: "nowrap", flexShrink: 0 }}>
            ⏱ <span style={{ color: "#3b82f6" }}>{doneMin}</span>/{totalMin}분
          </span>

          <div style={{ flex: 1 }} />{/* 빈 공간 채움 */}

          <button onClick={() => onEdit(item)} style={{
            ...btnCompact,
            border: "0.5px solid #e2e8f0", background: "#fff", color: "#374151",
          }}>
            ✏️ 수정
          </button>
          <button onClick={onClose} style={{
            background: "none", border: "none", fontSize: 18,
            cursor: "pointer", color: "#94a3b8", lineHeight: 1,
            padding: "2px 4px", flexShrink: 0, width: "fit-content",
          }}>
            ×
          </button>
        </div>

        {/* ── 진행률 바 ──────────────────────────────────── */}
        <div className={styles.progressBar} style={{ marginBottom: 14 }}>
          <div className={styles.progressFill} style={{ width: `${progress}%` }} />
        </div>

        {/* ── 업무 내용 ──────────────────────────────────── */}
        <div className={styles.contentBox} style={{ marginBottom: 16 }}>
          {item.content}
        </div>

        {/* ── 단계 현황 ──────────────────────────────────── */}
        <div style={{ marginBottom: 20 }}>
          <div className={styles.sectionLabel} style={{ marginBottom: 12 }}>처리 단계 현황</div>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>

            {item.steps.map((step, i) => {
              const cfg = STEP_MAP[step.step_type] ?? {
                label: step.step_type,
                icon:  "📌",
                color: "#64748b",
                defaultMin: step.minutes ?? 5,
              };
              const min = getMin(step);


              return (
                <div key={step.id} style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: 24, flexShrink: 0 }}>
                    <div className={styles.timelineDot} style={{
                      background:  step.is_done ? cfg.color : "#f1f5f9",
                      borderColor: step.is_done ? cfg.color : "#e2e8f0",
                      color:       step.is_done ? "#fff"    : "#94a3b8",
                    }}>
                      {step.is_done ? "✓" : i + 1}
                    </div>
                    {i < item.steps.length - 1 && <div className={styles.timelineLine} />}
                  </div>

                  <div className={styles.stepCard} style={{
                    background:  step.is_done ? cfg.color + "10" : "#f8fafc",
                    borderColor: step.is_done ? cfg.color + "50" : "#e2e8f0",
                  }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8, whiteSpace: "nowrap" }}>
                      <span style={{ fontSize: 16 }}>{cfg.icon}</span>
                      <div>
                        <div style={{ display: "flex", alignItems: "center", gap: 6, whiteSpace: "nowrap" }}>
                          <span style={{ fontSize: 13, fontWeight: 600, color: step.is_done ? cfg.color : "#94a3b8", whiteSpace: "nowrap" }}>
                            {cfg.label}
                          </span>
                          <span className={styles.minChip} style={{
                            background: step.is_done ? cfg.color + "20" : "#e2e8f0",
                            color:      step.is_done ? cfg.color : "#94a3b8",
                            whiteSpace: "nowrap",
                          }}>
                            ⏱ {min}분
                          </span>
                        </div>
                        {step.note && (
                          <div style={{ fontSize: 12, color: "#64748b", marginTop: 2 }}>{renderNote(step.note)}</div>
                        )}


                      </div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }}>
                      {step.is_done && step.done_at && (
                        <span style={{ fontSize: 11, color: "#94a3b8", whiteSpace: "nowrap" }}>
                          {new Date(step.done_at).toTimeString().slice(0, 5)}
                        </span>
                      )}
                      <button onClick={() => onToggleStep(item.id, step.id, !step.is_done)} style={{
                        ...btnCompact, border: "none",
                        background: step.is_done ? "#f1f5f9" : cfg.color,
                        color: step.is_done ? "#64748b" : "#fff",
                      }}>
                        {step.is_done ? "취소" : "완료 처리"}
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* ── 하단 삭제 버튼 ─────────────────────────────── */}
        <div style={{ display: "flex", justifyContent: "flex-start" }}>
          {confirmDelete ? (
            <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
              <span style={{ fontSize: 12, color: "#ef4444", whiteSpace: "nowrap" }}>정말 삭제할까요?</span>
              <button onClick={() => onDelete(item.id)} style={{
                ...btnCompact, border: "none", background: "#ef4444", color: "#fff",
              }}>삭제</button>
              <button onClick={() => setConfirmDelete(false)} style={{
                ...btnCompact, border: "0.5px solid #fecaca", background: "#fff", color: "#ef4444",
              }}>취소</button>
            </div>
          ) : (
            <button onClick={() => setConfirmDelete(true)} style={{
              ...btnCompact, border: "0.5px solid #fecaca", background: "#fff", color: "#ef4444",
            }}>삭제</button>
          )}
        </div>

      </div>
    </div>
  );
}